import httpClient from "@/apis/base/axios-httpclient";
import BaseAPI from "@/apis/base/base-api";
class RevenueManagementAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "PaymentRequest";
  controllerName = "paymentrequests";
  /**
   * @override: Lấy dữ liệu danh sách
   * Created by: TMQUY 28/08/2021
   */
  getList(payload) {
    // URL mặc định
    let param = {
      maxResultCount: payload.take || 20,
      filter: payload.filter || null,
      skipCount: payload.skip || 0,
      sorting: payload.Sort || null,
      status: payload.status || 0,
    };
    let url = this.getAPIUrl() + "/list";
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }
  /**
   * Tạo khoản thu
   * CreatedBy: tmquy (15/06/2022)
   */
  createPaymentRequest(value) {
    var param = {
      request: value ? value.request : null,
      customer: value ? value.customer : null,
    };
    let url = this.getAPIUrl();
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Sửa YCTT
   * CreatedBy: tmquy (15/06/2022)
   */
  editPaymentRequest(value) {
    var param = {
      request: value ? value.request : null,
      customer: value ? value.customer : null,
    };
    let url = this.getAPIUrl() + "/edit";
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.putAsync(request);
  }

  /**
   * Chuyển đợt thu
   * CreatedBy: pvtruong (12/07/2022)
   */
  transitionPaymentRequest(value) {
    var param = value ? value : null;
    let url = this.getAPIUrl() + "/transition";
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.putAsync(request);
  }

  /**
   * Gửi yêu cầu thanh toán
   * CreatedBy: tmquy (20/06/2022)
   */
  sendPaymentRequest(value) {
    let url = this.getAPIUrl() + "/sendmulti";
    let request = {
      url: url,
      data: value,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin theo id
   * CreatedBy: tmquy (21/06/2022)
   */
  getById(id) {
    let url = this.getAPIUrl() + `/${id}`;
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin type default
   * CreatedBy: tmquy (23/06/2022)
   */
  getTypeDefaultAsync() {
    let url = [window._apis["PaymentRequest"], "timeline/types"].join("/");
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin type MerchantApplication
   * CreatedBy: tmquy (23/06/2022)
   */
  getMerchantApplicationSyncs(merchantCode) {
    let url =
      [window._apis["PaymentRequest"], "merchantapplicationsyncs/"].join("/") + merchantCode;
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin tích hợp
   * CreatedBy: tmquy (29/06/2022)
   */
  getApplicationSyncs() {
    let url = window._apis["PaymentRequest"] + "/applicationsyncs";
    let request = {
      url: url,
    };
    // Call api
    return httpClient.getAsync(request);
  }

  /**
   * Xóa bản ghi
   * CreatedBy: tmquy (27/06/2022)
   */
  deleteAsync(id) {
    let url = this.getAPIUrl() + `?id=${id}`;
    let request = {
      url: url,
    };
    return httpClient.deleteAsync(request);
  }

  /**
   * Cập nhật bản ghi
   * CreatedBy: tmquy (27/06/2022)
   */
  updateAsync(item) {
    let url = this.getAPIUrl();
    let request = {
      url: url,
      data: item,
    };
    return httpClient.putAsync(request);
  }

  /**
   * Cập nhật bản ghi
   * CreatedBy: tmquy (27/06/2022)
   */
  updateMultiAsync(items) {
    let url = this.getAPIUrl() + "/multi";
    let request = {
      url: url,
      data: items,
    };
    return httpClient.putAsync(request);
  }

  /**
   * đánh dấu đã thanh toán cho nhiều yctt
   * CreatedBy: tmquy (27/06/2022)
   */
  markMultiAsync(items) {
    let url = this.getAPIUrl() + "/markmulti";
    let request = {
      url: url,
      data: items,
    };
    return httpClient.putAsync(request);
  }

  /**
   * Lấy thông tin checkout
   * CreatedBy: tmquy (15/07/2022)
   */
  getCheckoutById(id) {
    let url = this.getAPIUrl() + `/checkout/${id}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin checkout
   * CreatedBy: tmquy (15/07/2022)
   */
  getCheckoutOrder(id, amount, feeAmount, paymentType) {
    let url =
      this.getAPIUrl() +
      `/checkout/order?id=${id}&amount=${amount}&feeAmount=${feeAmount}&paymentType=${paymentType}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Kiểm tra đã sinh đề nghị lập chứng từ chưa
   * CreatedBy: pvtruong (01/08/2022)
   */
  CheckIsSaveVoucher(id) {
    let url = this.getAPIUrl() + `/issavevoucher/${id}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }
  /**
   * Lấy fee
   * CreatedBy: tmquy (03/08/2022)
   */
  getFeebyMerchantCode(payload) {
    let url =
      this.getAPIUrl() +
      `/fee?MerchantCode=${payload.merchantCode}&PaymentType=${payload.paymentType}&Amount=${payload.amount}`;
    let request = {
      url: url,
    };
    return httpClient.getAsync(request);
  }
}
export default new RevenueManagementAPI();
